import axios from "../config/axios";
import { useQuery } from "react-query";

// [5-1]
const getTocRecordsById = async (toc_id:string)=>{
  const res = await axios.GENERAL.get("/tocrecords/by_toc_id/"+toc_id)
  if (res.status === 200) {
    console.log("getTocRecordsById", res)
    return res.data
  }
}
// [5-2]
// INPUT
// words_in_tocrecord: ['text', ‘text’, ….]
const getTocRecordSearch = async (rtext:string[]) => {
  const res = await axios.GENERAL.post(
    "/tocrecords/search_by_record_text",
    {"words_in_tocrecord": rtext});
  if (res.status === 200) {
    console.log("getTocRecordSearch", res);
    return res.data;
  }
}
// [5-3]
// INPUT
// words_in_usernote: ['text', ‘text’, ….]
const getTocRecordsByUsernote = async (usernotes:string[])=>{
  const res = await axios.GENERAL.post(
    "/tocrecords/search_by_usernote",
    {"words_in_usernote":usernotes});
  if (res.status === 200) {
    console.log("getTocRecordsByUsernote", res);
    return res.data;
  }
}
// relation
// [17]
// INPUT
// school_id \ if null select All
// person_id\ if null select All
// region_id\ if null select All
const getTocrecordsBySPR = async (query: any) => {
  const res = await axios.GENERAL.post("/tocrecords/relation", query)
  if (res.status === 200) {
    console.log("getTocrecordsBySPR", res);
    return res.data
  }
}

// [17-1]
const getTocrecordsBySchoolId = async (school_id: string) => {
  const res = await axios.GENERAL.get("/tocrecords/related_by_school/" + school_id)
  if (res.status === 200) {
    console.log("getTocrecordsBySchoolId", res);
    return res.data
  }
}
// [17-2]
const getTocrecordsByPersonId = async (person_id: string) => {
  const res = await axios.GENERAL.get("/tocrecords/related_by_person/" + person_id)
  if (res.status === 200) {
    console.log("getTocrecordsByPersonId", res)
    return res.data
  }
}
// [17-3]
const getTocrecordsByRegionId = async (region_id: string) => {
  const res = await axios.GENERAL.get("/tocrecords/related_by_region/" + region_id)
  if (res.status === 200) {
    console.log("getTocrecordsByRegionId", res);
    return res.data
  }
}


export default {
  getTocRecordsById,
  getTocRecordSearch,
  getTocRecordsByUsernote,
  getTocrecordsBySPR,
  getTocrecordsBySchoolId,
  getTocrecordsByPersonId,
  getTocrecordsByRegionId
};

